// extracted by mini-css-extract-plugin
export var compact = "vmbuG";
export var contentColumn = "rmkwf";
export var contentGap1 = "DZcLD";
export var contentGap2 = "dy4PU";
export var contentGap3 = "gjqRi";
export var contentLine1 = "hMmbR";
export var contentLine2 = "dk2NL";
export var contentLine3 = "VqVru";
export var full = "vn9Mk";
export var mailListShimmerContainer = "pXwdB";
export var paddingFirstMessage = "_eE88";
export var paddingMessage = "S11yW";
export var personaColumn = "Ekjub";
export var personaGap = "t9hx3";
export var shimmerRow = "LesyR";